// Import type definitions
import MutatorTools from '@/tools/MutatorTools';
import AsyncTools from '@/tools/AsyncTools';
import DynamicImportHelper from '@/tools/DynamicImportHelper';
import MediaTools from '@/tools/MediaTools';
import MiscTools from '@/tools/MiscTools';
import RangeTools from '@/tools/RangeTools';
import { UniqueRandomGenerator } from '@/tools/UniqueRandomGenerator';

export interface ToolSet {
  MutatorTools: typeof MutatorTools;
  AsyncTools: typeof AsyncTools;
  DynamicImportHelper: typeof DynamicImportHelper;
  MediaTools: typeof MediaTools;
  MiscTools: typeof MiscTools;
  RangeTools: typeof RangeTools;
  UniqueRandomGenerator: typeof UniqueRandomGenerator;
}

// Export a function that returns an object containing the imported tools
export function useTools(): ToolSet {
  return {
    MutatorTools,
    AsyncTools,
    DynamicImportHelper,
    MediaTools,
    MiscTools,
    RangeTools,
    UniqueRandomGenerator,
  };
}
